import PropTypes from 'prop-types';

import SchemaJsonLd from './SchemaJsonLd';

const FaqJsonLd = ({ faqItems }) => {
  if (!faqItems?.length) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  };

  return <SchemaJsonLd id="faq-schema" schema={schema} />;
};

FaqJsonLd.propTypes = {
  faqItems: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default FaqJsonLd;
